import React from "react";
import { useState } from "react";
import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import * as Clipboard from "expo-clipboard";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import ConfirmEmail from "../../components/ConfirmEmail/ConfirmEmail";
import { styles } from "./styles";
import { useNavigation } from "@react-navigation/core";
import { useRoute } from "@react-navigation/native";
import toast from "../../utils/toast";
import AsyncStorage from "@react-native-async-storage/async-storage";
import paymentService from "../../services/paymentService";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";

const WithdrawGPXPassword = () => {
  const txId = "1230120302130210302103213120138128392183218931892183219392132";

  const [emailCode, setEmailCode] = useState();
  const [emailVerified, setEmailVerified] = useState(false);

  const [password, setPassword] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigation = useNavigation();
  const route = useRoute();

  const intl = useIntl();

  function onModalClose() {
    setModalVisible(false);
    navigation.navigate("Home");
  }

  function copyTxId() {
    Clipboard.setString(txId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  async function createTransfer() {
    if (!emailVerified) {
      toast(
        intl.formatMessage({ id: "withdrawgpxpassword.verifiqueEmail" }),
        "#DA1414"
      );
      return;
    }
    const { value, bankAccountId } = route.params;

    const token = await AsyncStorage.getItem("JWT_TOKEN");

    try {
      setIsLoading(true);
      await paymentService.createTransfer(token, value, bankAccountId);
      setModalVisible(true);
    } catch (err) {
      console.log(err);
      if (err.response?.data?.message)
        toast(err.response.data.message, "#DA1414");
      else
        toast(
          intl.formatMessage({ id: "withdrawgpxpassword.tenteNovamente" }),
          "#DA1414"
        );
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <View style={{}}>
        <HeaderTabs
          title={<FormattedMessage id="withdrawgpxpassword.confirmarSaque" />}
          subtitle={
            <FormattedMessage id="withdrawgpxpassword.confirmarSaque" />
          }
        />

        <View style={styles.container}>
          <View style={{ marginVertical: 12 }}>
            <Text style={styles.cardTitleTxt}>
              <FormattedMessage id="withdrawGpx.confirmacaoSaque" />
            </Text>
          </View>
          <View style={styles.containerPasswd}>
            <FormattedMessage id="withdrawgpxpassword.digiteSenha">
              {(placeholder) => (
                <AuthCodeInput
                  cellCount={6}
                  isPassword={true}
                  value={password}
                  onValueChange={(value) => setPassword(value)}
                  label={placeholder}
                />
              )}
            </FormattedMessage>
            <ConfirmEmail
              onChange={(value) => setEmailCode(value)}
              onVerified={(value) => setEmailVerified(value)}
            />
          </View>

          <View style={styles.containerBtns}>
            <TouchableOpacity
              onPress={() => navigation.goBack()}
              style={styles.btnCancelar}
            >
              <FormattedMessage id="withdrawgpxpassword.cancelar" />
            </TouchableOpacity>

            <TouchableOpacity
              onPress={createTransfer}
              style={styles.btnConfimeSaque}
            >
              <FormattedMessage id="withdrawgpxpassword.sacar" />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <Modal
        animationType="slide"
        visible={modalVisible}
        presentationStyle="fullscreen"
        onRequestClose={onModalClose}
        style={styles.modal}
      >
        <View style={styles.modalContainer}>
          <TouchableOpacity onPress={onModalClose} style={styles.modalClose}>
            <MaterialIcons name="close" size={30} color="black" />
          </TouchableOpacity>
          <Image
            style={styles.modalSuccess}
            source={require("../../../assets/success.png")}
          ></Image>
          <Text style={styles.modalText}>
            <FormattedMessage id="withdrawgpxpassword.SaqueEnviado" />
            {"\n"}

            <FormattedMessage id="withdrawgpxpassword.emBreveRecebera" />
            {"\n"}
            <FormattedMessage id="withdrawgpxpassword.emSuaConta" />
          </Text>
          <Image
            resizeMode="contain"
            style={styles.modalImage}
            source={require("../../../assets/imgs/cardCoin.png")}
          />
        </View>
      </Modal>
    </>
  );
};

export default WithdrawGPXPassword;
